import * as React from 'react';
import '../../Css/Global/Global.css';

import { Grid } from "@mui/material";

import TableIcmsPerdas from './TableIcmsPerdas';
import TopChartWithTable from '../../Components/TopChartWithTable';
import BarChartIcmsPorProduto from './BarChartIcmsPorProduto';

import MoneyOffIcon from '@mui/icons-material/MoneyOff';

import { IcmsPorPerdas, PerdasHistoricoData } from './types';
import SpedStatusHandler from '../Dashboard/SpedStatusHandler';
import InfoCard from '../Dashboard/InfoCard';
import PerdasPorMesChart from './PerdasPorMesChart';
import { EstablishmentStorageUtils } from '../../Storages/establishmentStorage';



const AnalisesPerdas: React.FC = () => {

    const [loading, setLoading] = React.useState(true);

    const [spedFiscalIdSelecionado, setSpedFiscalIdSelecionado] = React.useState<number | null>(null);
    
    // Estado para armazenar o establishment_id atual
    const [establishmentId, setEstablishmentId] = React.useState<string | number | null>(null);

    const [dadosPerdasIcms, setDadosPerdasIcms] = React.useState<IcmsPorPerdas[]>([]);
    const [dadosPerdasPorProduto, setDadosPerdasPorProduto] = React.useState<{ produto: string; ICMS: number }[]>([]);

    const [historicoPerdas, setHistoricoPerdas] = React.useState<PerdasHistoricoData[]>([]);

    // Effect para atualizar establishmentId quando página carrega
    React.useEffect(() => {
        const establishmentData = EstablishmentStorageUtils.get();
        if (establishmentData?.establishment_id) {
            setEstablishmentId(establishmentData.establishment_id);
        }
    }, []);

    // Função separada para buscar histórico de perdas
    const fetchHistoricoPerdas = React.useCallback(async () => {
        const establishmentData = EstablishmentStorageUtils.get();
        const currentEstablishmentId = establishmentData?.establishment_id;

        if (currentEstablishmentId) {
            try {

              const token = document.cookie
                .split('; ')
                .find((row) => row.startsWith('authTokenMHP='))
                ?.split('=')[1];
          
              const historicoPerdasResponse = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/historico-perdas/12/${currentEstablishmentId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept': 'application/json'
                    }
              });

                const historicoPerdasData = await historicoPerdasResponse.json();
                setHistoricoPerdas(historicoPerdasData);
            } catch (e) {
                console.error('Erro ao carregar histórico de perdas', e);
                setHistoricoPerdas([]);
            }
        } else {
            console.warn('Estabelecimento não selecionado para histórico de perdas');
            setHistoricoPerdas([]);
        }
    }, []);

    // Effect adicional para recarregar histórico quando estabelecimento mudar
    React.useEffect(() => {
        if (establishmentId) {
            fetchHistoricoPerdas();
        }
    }, [establishmentId, fetchHistoricoPerdas]);

    React.useEffect(() => {
      if (Number(spedFiscalIdSelecionado) > 0){
        const fetchData = async () => {
          try {
            setLoading(true);
            const response = await fetch(process.env.REACT_APP_API_URL+'perdas-por-cfop/'+spedFiscalIdSelecionado);
            const data = await response.json();
      
            // Aqui você pode validar se os dados têm a estrutura esperada
            if (Array.isArray(data)) {
              setDadosPerdasIcms(data);
            } else {
              console.error('Dados de produtos inválidos:', data);
            }

            // gráfico top 20
            const responseTop = await fetch(process.env.REACT_APP_API_URL+'top20-perdas/'+spedFiscalIdSelecionado);
            const topData = await responseTop.json();

            if (Array.isArray(topData)) {
              const formatado = topData.map((item: any) => ({
                produto: `${item.cod_item} - ${item.descr_compl}`,
                ICMS: item.valor_total_perda,
              }));
              setDadosPerdasPorProduto(formatado);
            } else {
              console.error('Dados de perdas top 20 inválidos:', topData);
            }

            // Chama função separada para histórico de perdas
            await fetchHistoricoPerdas();
            

          } catch (e) {
            console.error('Erro ao carregar dados de produtos ICMS', e);
          } finally {
            setLoading(false);
          }
        };
      
        fetchData();
      }
    }, [spedFiscalIdSelecionado]);

    return (
        <>
            <Grid container spacing={0.5}>

              <SpedStatusHandler
                  onSpedFiscalIdChange={(id) => {
                      setSpedFiscalIdSelecionado(id); // exemplo de uso
                  }}
              />

              <InfoCard title="Análise de Perdas de produtos" icon={<MoneyOffIcon />} iconColor="info" size={12} />

              <Grid item xs={12} md={12} lg={12}>
                <BarChartIcmsPorProduto
                  data={dadosPerdasPorProduto}
                  title="TOP 10 Perdas por Produto"
                  barColor="#f44336"
                  loading={loading}
                  spedFiscalId={spedFiscalIdSelecionado || undefined}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                  <TableIcmsPerdas
                    data={dadosPerdasIcms}
                    loading={loading}
                  />
              </Grid>

              <Grid item xs={12} md={12} lg={12}>
                  <PerdasPorMesChart data={historicoPerdas} loading={loading} />
              </Grid>

            </Grid>              
        </>
      );
      
}


export default AnalisesPerdas;

